module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalTheme', {
    attrs: {
      "with-content": true,
      "theme": true,
      "fix-height": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', [_c('div', {
    staticClass: "headline bold"
  }, [_vm._v("Add item to forecast")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('CatalogueItemDescription', {
    attrs: {
      "item": _vm.convertedItem
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('div', [_c('div', [_vm._v("Select forecast")]), _vm._v(" "), _c('ItemManager', {
    attrs: {
      "item": _vm.convertedItem,
      "do-save": _vm.doSave
    },
    on: {
      "saved": function($event) {
        _vm.doSave = false;
        _vm.closeModal();
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "end"
  }, [_c('div', [_c('ClientColorButton', {
    on: {
      "click": function($event) {
        _vm.doSave = true;
      }
    }
  }, [_vm._v("Save")])], 1)])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcd61e60","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/catalogue/Modal.vue
// module id = 3408
// module chunks = 0